<template>
  <div class="error-div">
    <img src="/static/geopsicon.gif" height="40" width="40"/>
    <div class="indications">
      <h1>404 - Seite wurde nicht gefunden</h1>
      Die angeforderte Seite „{{ baseUrl }}{{ url }}“ wurde nicht gefunden.
    </div>
    <a href="http://geops.ch/impressum">geOps Kontakt</a>
  </div>
</template>

<script>
export default {
  name: 'error-page',

  created() {
    this.baseUrl = window.location.origin;
    this.url = (this.$route.query.path) ?
      `${this.$route.path}${this.$route.query.path}` :
      this.$route.path;
  },
};
</script>

<style>
.error-div {
  padding: 150px 15px 150px 15px;
}

.indications {
  padding-bottom: 10px;
}

.error-div a, .error-div a:visited {
  color: #61849c;
}
</style>



// WEBPACK FOOTER //
// PageNotFound.vue?4eb34a48